import { MotorStatusMdl } from './../../../Models/MotorStatusMdl';
import { CompAttachmentsMdl, mdlattachments, mdlStatus } from './../../../Models/CompAttachmentsMdl';
import { LanguageService } from './../../../Services/languageService';
import { MotorproposalTrackingService } from './../../../Services/MotorproposalTrackingService';
import { Subscription } from 'rxjs';
import { Component } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { BindMdl } from '../../../Models/BindMdl';
import { MotorProposal } from '../../../Models/MotorProposal';
import { OnInit } from '@angular/core';
import { restURL } from '../../../Models/restURL';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AddNewPolicyReqMdl } from '../../../Models/AddNewPolicyReqMdl';
import { motorProposalService } from '../../../Services/motorProposalService';
import { userService } from '../../../Services/userService';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';




@Component({
  selector: 'uploadsForm',
  templateUrl: './uploadsForm.html',
  styleUrls: ['./uploadsForm.css']
})


export class uploadsForm {

  public prObj: MotorProposal = new MotorProposal();
  public bindObj: BindMdl = new BindMdl();
  //public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
  public isShowLoading: boolean;
  public LngSubscription: Subscription;
  public Lng: string;
  public isError: boolean;
  public ErrorMsg: string;
  public frontUrl: string;
  public backUrl: string;
  public LeftUrl: string;
  public RightUrl: string;
  public ChasisUrl: string;
  public compdeclare: boolean = false;
  public attachments: mdlattachments = new mdlattachments();
  public headers = new HttpHeaders();
  public statusObj: MotorStatusMdl = new MotorStatusMdl();
  //public cocoSsd: any;
  public strAttachmentId: string;



  public constructor(public objRest: restURL, public Translate: TranslateService, private EncriptService: motorProposalService, private router: Router, private http: HttpClient, public url: restURL, private proposalService: motorProposalService, private lngService: LanguageService, private trackingObj: MotorproposalTrackingService, private userinfo: userService) {

    this.headers.delete('Content-Type');
    this.headers.set('enctype', "multipart/form-data");
    this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });

    if (sessionStorage.getItem("Language") != null) {
      this.Lng = sessionStorage.getItem("Language");
    }
    else {
      this.Lng = "en";
    }
    this.prObj = this.proposalService.getProposalObj();
    this.isShowLoading = false;
    this.isError = false;
    this.ErrorMsg = "";
    this.bindObj = this.proposalService.getBindObj();



    // if (localStorage.getItem("frontUrl") != null) {
    //   this.frontUrl = localStorage.getItem("frontUrl");
    // }
    // if (localStorage.getItem("backUrl") != null) {
    //   this.backUrl = localStorage.getItem("backUrl");
    // }
    // if (localStorage.getItem("LeftUrl") != null) {
    //   this.LeftUrl = localStorage.getItem("LeftUrl");
    // }
    // if (localStorage.getItem("RightUrl") != null) {
    //   this.RightUrl = localStorage.getItem("RightUrl");
    // }
    // if (localStorage.getItem("ChasisUrl") != null) {
    //   this.ChasisUrl = localStorage.getItem("ChasisUrl");
    // }

    // if (sessionStorage.getItem("frontImg") != null) {
    //   this.prObj.frontImage = sessionStorage.getItem("frontImg");
    //   this.attachments.frontImage = sessionStorage.getItem("frontImg");
    // }
    // if (sessionStorage.getItem("backImg") != null) {
    //   this.prObj.backImage = sessionStorage.getItem("backImg");
    //   this.attachments.backImage = sessionStorage.getItem("backImg");
    // }
    // if (sessionStorage.getItem("leftImg") != null) {
    //   this.prObj.leftImage = sessionStorage.getItem("leftImg");
    //   this.attachments.leftImage = sessionStorage.getItem("leftImg");
    // }
    // if (sessionStorage.getItem("rightImg") != null) {
    //   this.prObj.rightImage = sessionStorage.getItem("rightImg");
    //   this.attachments.rightImage = sessionStorage.getItem("rightImg");
    // }
    // if (sessionStorage.getItem("ChasisImg") != null) {
    //   this.prObj.chasisImage = sessionStorage.getItem("ChasisImg");
    //   this.attachments.chasisImage = sessionStorage.getItem("ChasisImg");
    // }

    // if (sessionStorage.getItem("InsuredIdImg") != null) {
    //   this.prObj.InsuredIdImage = sessionStorage.getItem("InsuredIdImg");
    //   this.attachments.InsuredIdImage =  sessionStorage.getItem("InsuredIdImg");
    // }

    // if (   sessionStorage.getItem("IstimaraImg")!= null) {
    //   this.prObj.IstharamaImage = sessionStorage.getItem("IstimaraImg");
    //   this.attachments.IsthimaraImage = sessionStorage.getItem("IstimaraImg");
    // }


    // New Logic Start
    this.strAttachmentId = "Motor_" + this.prObj.EditedProposalNo;

    if (this.prObj.frontImage != null) {
      this.attachments.frontImage = this.objRest.AttachmentUrl + this.prObj.frontImage;
    }
    else if (sessionStorage.getItem("frontImg") != null) {
      this.prObj.frontImage = sessionStorage.getItem("frontImgFileName");
      this.attachments.frontImage = this.objRest.AttachmentUrl + this.prObj.frontImage;
    }


    if (this.prObj.backImage != null) {
      this.attachments.backImage = this.objRest.AttachmentUrl + this.prObj.backImage;
    }
    else if (sessionStorage.getItem("backImg") != null) {
      this.prObj.backImage = sessionStorage.getItem("backImgFileName");
      this.attachments.backImage = this.objRest.AttachmentUrl + this.prObj.backImage;
    }

    if (this.prObj.rightImage != null) {
      this.attachments.rightImage = this.objRest.AttachmentUrl + this.prObj.rightImage;
    }
    else if (sessionStorage.getItem("rightImg") != null) {
      this.prObj.rightImage = sessionStorage.getItem("rightImgFileName");
      this.attachments.rightImage = this.objRest.AttachmentUrl + this.prObj.rightImage;
    }

    if (this.prObj.leftImage != null) {
      this.attachments.leftImage = this.objRest.AttachmentUrl + this.prObj.leftImage;
    }
    else if (sessionStorage.getItem("leftImg") != null) {
      this.prObj.leftImage = sessionStorage.getItem("leftImgFileName");
      this.attachments.leftImage = this.objRest.AttachmentUrl + this.prObj.leftImage;
    }




    if (this.prObj.chasisImage != null) {
      this.attachments.chasisImage = this.objRest.AttachmentUrl + this.prObj.chasisImage;
    }
    else if (sessionStorage.getItem("chasisImg") != null) {
      this.prObj.chasisImage = sessionStorage.getItem("chasisImgFileName");
      this.attachments.chasisImage = this.objRest.AttachmentUrl + this.prObj.chasisImage;
    }

    if (this.prObj.InsuredIdImage != null) {
      this.attachments.InsuredIdImage = this.objRest.AttachmentUrl + this.prObj.InsuredIdImage;
    }
    else if (sessionStorage.getItem("InsuredIdImg") != null) {
      this.prObj.InsuredIdImage = sessionStorage.getItem("InsuredIdImgFileName");
      this.attachments.InsuredIdImage = this.objRest.AttachmentUrl + this.prObj.InsuredIdImage;
    }

    if (this.prObj.IsthimaraImage != null) {
      this.attachments.IsthimaraImage = this.objRest.AttachmentUrl + this.prObj.IsthimaraImage;
    }
    else if (sessionStorage.getItem("IsthimaraImg") != null) {
      this.prObj.IsthimaraImage = sessionStorage.getItem("IsthimaraImgFileName");
      this.attachments.IsthimaraImage = this.objRest.AttachmentUrl + this.prObj.IsthimaraImage;
    }

    if (this.prObj.CustomIdImage != null) {
      this.attachments.CustomIdImage = this.objRest.AttachmentUrl + this.prObj.CustomIdImage;
    }
    else if (sessionStorage.getItem("CustomIdImg") != null) {
      this.prObj.CustomIdImage = sessionStorage.getItem("CustomIdFileName");
      this.attachments.CustomIdImage = this.objRest.AttachmentUrl + this.prObj.CustomIdImage;
    }

    // require("@tensorflow/tfjs-backend-cpu");
    // require("@tensorflow/tfjs-backend-webgl");
    // this.cocoSsd = require("@tensorflow-models/coco-ssd");

    //New Logic End
  }




  uploadFileOld(fd) {
    var param = environment;              
    if (!param.St.StatusDesc) {
        throw new Error("Encryption key is not initialized.");
    }

    var UserName = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Code));
    var Password = this.EncriptService.EncriptPayload(JSON.stringify(param.Master.Description));
    
    this.isShowLoading = true;

    this.headers = new HttpHeaders();
    this.headers.delete('Content-Type');
    this.headers.set('enctype', "multipart/form-data");
    this.headers = this.headers.append('Accept-Encoding', 'gzip');
    this.headers = this.headers.append('apiToken', this.getToken());
    this.headers = this.headers.append("Authorization", "Basic " + btoa(UserName + ':' + Password));

    this.http.post<MotorStatusMdl>(this.url.baseURL + "/Proposal/SaveAttachments", fd, { headers: this.headers }).toPromise().then(
      function (res) {

      },
      function (res) {
        this.isShowLoading = false;
      });
    this.isShowLoading = false;
  }

  onSelectFrontFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.prObj.ProposalFormFileName = fileName;

      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        Swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        this.attachments.frontImage = null;
        Swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "front");
      fd.append("attchmentId", this.prObj.attachmentId.toString())

      this.uploadFileOld(fd);
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.attachments.frontImage = image.split(",")[1];
          this.prObj.frontImageExists = true;
          sessionStorage.setItem("frontImg", this.attachments.frontImage);
        }
      }
    }
  }

  onSelectBackFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.prObj.IqamaCopyFileName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        Swal("Please select valid image");
        return;
      }

      var isvalid = "";

      if (fsize > 2) {
        this.attachments.backImage = null;
        Swal("File Size Should not exceed 2 MB"); return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "back");
      fd.append("attchmentId", this.prObj.attachmentId.toString());
      this.uploadFileOld(fd);
      reader.onload = (event) => {

        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.attachments.backImage = image.split(",")[1];
          this.prObj.backImageExists = true;
          sessionStorage.setItem("backImg", this.attachments.backImage);
        }

      }
    }
  }

  onSelectLeftFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.prObj.VehicleRegFileName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        Swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        this.attachments.leftImage = null;
        Swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "left");
      fd.append("attchmentId", this.prObj.attachmentId.toString());
      this.uploadFileOld(fd);
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.attachments.leftImage = image.split(",")[1];
          this.prObj.leftImageExists = true;
          sessionStorage.setItem("leftImg", this.attachments.leftImage);
        }

      }
    }
  }

  onSelectRightFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.prObj.DrivingLicFileName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        Swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        this.attachments.rightImage = null;
        Swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "right");
      fd.append("attchmentId", this.prObj.attachmentId.toString());
      this.uploadFileOld(fd);
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.attachments.rightImage = image.split(",")[1];
          this.prObj.rightImageExists = true;
          sessionStorage.setItem("rightImg", this.attachments.rightImage);
        }

      }
    }
  }


  onSelectChasisFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.prObj.OtherFileName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        Swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        this.attachments.chasisImage = null;
        Swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "Chasis");
      fd.append("attchmentId", this.prObj.attachmentId.toString());
      this.uploadFileOld(fd);
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.attachments.chasisImage = image.split(",")[1];
          this.prObj.chasisImageExists = true;
          sessionStorage.setItem("ChasisImg", this.attachments.chasisImage);
        }

      }
    }
  }


  onSelectInsuredIdFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.prObj.OtherFileName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        Swal("Please select valid image");
        return;
      }
      var isvalid = "";
      if (fsize > 2) {
        this.attachments.InsuredIdImage = null;
        Swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "InsuredId");
      fd.append("attchmentId", this.prObj.attachmentId.toString());
      this.uploadFileOld(fd);

      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.attachments.InsuredIdImage = image.split(",")[1];
          this.prObj.InsuredIdImageExists = true;
          sessionStorage.setItem("InsuredIdImg", this.attachments.InsuredIdImage);
        }

      }
    }
  }



  onSelectIstimaraFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]);
      var fsize = event.target.files[0].size / 1048576;
      var fileName = event.target.files[0].name;
      this.prObj.OtherFileName = fileName;
      var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);
      if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
        Swal("Please select valid image");
        return;
      }

      var isvalid = "";
      if (fsize > 2) {
        this.attachments.IsthimaraImage = null;
        Swal("File Size Should not exceed 2 MB");
        return;
      }
      var fd = new FormData();
      fd.append("file", event.target.files[0]);
      fd.append("fileType", "Istimara");
      fd.append("attchmentId", this.prObj.attachmentId.toString());
      this.uploadFileOld(fd);
      reader.onload = (event) => {
        if (fsize < 2) {
          let target = <any>event.target;
          let image = target.result;
          this.attachments.IsthimaraImage = image.split(",")[1];
          this.prObj.IstharamaImageExists = true;
          sessionStorage.setItem("IstimaraImg", this.attachments.IsthimaraImage);
        }

      }
    }
  }



  goPrev() {
    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    sessionStorage.setItem("CurrentRoute", "VehicleDetails");
    this.router.navigate(['NewDashboard/MotorProposalForm/VehicleDetails']);

  }
  goNext() {


    if (this.prObj.SelectedProductCode == "5515") {
      if (this.attachments.InsuredIdImage == null) {
        Swal(this.Translate.instant("Please upload Insured Id Copy to proceed further"))
        return;
      }

    }
    else if (this.prObj.SelectedProductCode == "5520") {
      if (this.attachments.backImage == null || this.attachments.frontImage == null || this.attachments.leftImage == null || this.attachments.rightImage == null || this.attachments.chasisImage == null || this.attachments.InsuredIdImage == null) {
        Swal(this.Translate.instant("Please upload all related documents to proceed further"))
        return;
      }
    }

    if (!this.compdeclare) {
      Swal(this.Translate.instant("Please Accept Terms and Conditions to proceed to next"))
      return;
    }

    this.proposalService.saveProposalObj(this.prObj);
    this.proposalService.saveBindObj(this.bindObj);
    if (this.prObj.isEditProposal == false) {
      this.prObj.trackingObj.ScreenNo = "U";
      this.trackingObj.saveTrackStatus(this.prObj)
    }

    sessionStorage.setItem("CurrentRoute", "ReviewConfirm");
    this.router.navigate(['NewDashboard/MotorProposalForm/ReviewConfirm']);


  }

  getToken(): string {
    let token: string = "";
    if (sessionStorage.getItem("token") != null) {
      token = sessionStorage.getItem("token");
    }
    return token;
  }


  //<<<<<<<<New Image Upload Logic Start>>>>>>>>>>>>

  /////<<<<<<<<<<<<<<<<New Logic Start>>>>>>>>>>>>>>>>>>>>>>>>>>>>



  processImage(event: any, filetype: string, isCarImage: boolean) {
    var fsize = event.target.files[0].size / 1048576;
    var fileName = event.target.files[0].name;
    var fileExt = fileName.substring(fileName.lastIndexOf(".") + 1);

    if (fileExt.toString().toUpperCase() != "JPG" && fileExt.toString().toUpperCase() != "JPEG" && fileExt.toString().toUpperCase() != "PNG") {
      Swal("Validation", "Please select valid image", "info");
      return;
    }
    if (fsize > 10) {
      Swal("Validation", "File Size Should not exceed 2 MB", "info");
      return;
    }

    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (event) => {
      if (fsize < 10) {
        let target = <any>event.target;
        let image = target.result;
        var Htmlimage = document.createElement("img");
        Htmlimage.src = target.result;

        //Create canvas to draw Car Image,Logo and Date Time .
        const canvas = document.createElement("canvas");
        const logo = new Image();
        const ctx = canvas.getContext("2d");
        if (ctx != null) {
          const tempImage = new Image();
          tempImage.onload = () => {

            canvas.width = tempImage.width;
            canvas.height = tempImage.height;
            // if (ctx != null) {
            ctx.drawImage(tempImage, 0, 0);
            ctx.font = tempImage.width / 50 + "px" + " Arial";
            var dateTime = this.GetTimeStamp();
            ctx.fillStyle = "#fff";
            ctx.textAlign = "start";
            ctx.fillText(
              dateTime,
              tempImage.width - tempImage.width / 5,
              tempImage.height - tempImage.height * 0.02
            );

            logo.src = "assets/Images/logo.png";
            logo.onload = () => {
              ctx.globalAlpha = 0.6;
              ctx.drawImage(
                logo,
                0,
                0,
                tempImage.width / 4,
                tempImage.height / 4
              );

              //drawing cross in the canvas
              ctx.lineWidth = tempImage.width / 9;
              ctx.beginPath();
              ctx.moveTo(0, 0);
              ctx.lineTo(canvas.width, canvas.height);
              ctx.globalAlpha = 0.2;
              ctx.strokeStyle = "#FFF";
              ctx.stroke();
              ctx.lineWidth = tempImage.width / 9;
              ctx.beginPath();
              ctx.moveTo(canvas.width, 0);
              ctx.lineTo(0, canvas.height);
              ctx.globalAlpha = 0.2;
              ctx.stroke();
            }

            //getting base64 from final canvas
            var base64 = canvas.toDataURL();

            image = base64;
            Htmlimage.src = base64;

            if (isCarImage) this.ImageFilter(Htmlimage, filetype)


            sessionStorage.setItem(`${filetype}ImgFileName`, this.strAttachmentId + "_" + filetype + "." + fileExt);
            // sessionStorage.setItem(`${filetype}Img`, image.split(",")[1]);


            if (filetype == "front") {
              this.attachments.frontBase64Image = image.split(",")[1];
              this.prObj.frontImage = this.strAttachmentId + "_" + filetype + "." + fileExt;
              this.attachments.frontImage = this.objRest.AttachmentUrl + this.prObj.frontImage;
              sessionStorage.setItem(`${filetype}Img`, this.attachments.frontImage);
              this.CreateFormDataAndUpload(base64, filetype, this.prObj.frontImage);
            }
            if (filetype == "back") {
              this.attachments.backBase64Image = image.split(",")[1];
              this.prObj.backImage = this.strAttachmentId + "_" + filetype + "." + fileExt;
              this.attachments.backImage = this.objRest.AttachmentUrl + this.prObj.backImage;
              sessionStorage.setItem(`${filetype}Img`, this.attachments.backImage);
              this.CreateFormDataAndUpload(base64, filetype, this.prObj.backImage);
            }
            if (filetype == "left") {
              this.attachments.leftBase64Image = image.split(",")[1];
              this.prObj.leftImage = this.strAttachmentId + "_" + filetype + "." + fileExt;
              this.attachments.leftImage = this.objRest.AttachmentUrl + this.prObj.leftImage;
              sessionStorage.setItem(`${filetype}Img`, this.attachments.leftImage);
              this.CreateFormDataAndUpload(base64, filetype, this.prObj.leftImage);
            }
            if (filetype == "right") {
              this.attachments.rightBase64Image = image.split(",")[1];
              this.prObj.rightImage = this.strAttachmentId + "_" + filetype + "." + fileExt;
              this.attachments.rightImage = this.objRest.AttachmentUrl + this.prObj.rightImage;
              sessionStorage.setItem(`${filetype}Img`, this.attachments.rightImage);
              this.CreateFormDataAndUpload(base64, filetype, this.prObj.rightImage);
            }
            if (filetype == "chasis") {
              this.attachments.chasisBase64Image = image.split(",")[1];
              this.prObj.chasisImage = this.strAttachmentId + "_" + filetype + "." + fileExt;
              this.attachments.chasisImage = this.objRest.AttachmentUrl + this.prObj.chasisImage;
              sessionStorage.setItem(`${filetype}Img`, this.attachments.chasisImage);
              this.CreateFormDataAndUpload(base64, filetype, this.prObj.chasisImage);
            }
            if (filetype == "InsuredId") {
              this.attachments.InsuredIdBase64Image = image.split(",")[1];
              this.prObj.InsuredIdImage = this.strAttachmentId + "_" + filetype + "." + fileExt;
              this.attachments.InsuredIdImage = this.objRest.AttachmentUrl + this.prObj.InsuredIdImage;
              sessionStorage.setItem(`${filetype}Img`, this.attachments.InsuredIdImage);
              this.CreateFormDataAndUpload(base64, filetype, this.prObj.InsuredIdImage);
            }
            if (filetype == "Isthimara") {
              this.attachments.IsthimaraBase64Image = image.split(",")[1];
              this.prObj.IsthimaraImage = this.strAttachmentId + "_" + filetype + "." + fileExt;
              this.attachments.IsthimaraImage = this.objRest.AttachmentUrl + this.prObj.IsthimaraImage;
              sessionStorage.setItem(`${filetype}Img`, this.attachments.IsthimaraImage);
              this.CreateFormDataAndUpload(base64, filetype, this.prObj.IsthimaraImage);
            }
            if (filetype == "CustomId") {
              this.attachments.CustomIdBase64Image = image.split(",")[1];
              this.prObj.CustomIdImage = this.strAttachmentId + "_" + filetype + "." + fileExt;
              this.attachments.CustomIdImage = this.objRest.AttachmentUrl + this.prObj.CustomIdImage;
              sessionStorage.setItem(`${filetype}Img`, this.attachments.CustomIdImage);
              this.CreateFormDataAndUpload(base64, filetype, this.prObj.CustomIdImage);
            }

          };
          tempImage.src = image;
        }

      }
    };
  }




  async ImageFilter(ImageId: any, ImageSide: any) {
    try {
      this.isShowLoading = true;

      let ChkImg: boolean = false;
      const img = document.getElementById(ImageId) as HTMLImageElement;
      await cocoSsd.load().then((model: any) => {
        model.detect(ImageId).then((predictions: any) => { 
          if (predictions.length > 0) {
            for (let i = 0; i < predictions.length; i++) {
              if (predictions[i].class == "car") {
                ChkImg = true;
              }
            }
          }
          if (!ChkImg) {
            if (predictions.length > 0)
              Swal(this.Translate.instant("Invalid Vehicle Image, Image Should Not Be " + predictions[0].class));
            else
              Swal(this.Translate.instant("Invalid Vehicle Image, Image Not Recognized By System"));
            this.ClearFileNames(ImageSide)
            if (ImageSide == "front") {
              this.attachments.frontImage = null;
            } else if (ImageSide == "back") {
              this.attachments.backImage = null;
            } else if (ImageSide == "left") {
              this.attachments.leftImage = null;
            } else if (ImageSide == "right") {
              this.attachments.rightImage = null;
            }
            return;
          }
        });
      });
    } catch {
    } finally {
      this.isShowLoading = false;
    }
  }


  CreateFormDataAndUpload_Old(base64: any, filetype: any, FileName: any) {

    //extract base64 without data:type
    const base64WithoutDataType = base64.split(",")[1];

    //base64 to file
    let byteCharacters = atob(base64WithoutDataType);
    let byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++)
      byteNumbers[i] = byteCharacters.charCodeAt(i);

    let byteArray = new Uint8Array(byteNumbers);
    let blob = new Blob([byteArray], { type: "image/jpg" });
    const fileToBeUploaded = new File([blob], FileName);

    var fd = new FormData();
    fd.append("file", fileToBeUploaded);
    fd.append("FileName", FileName);
    fd.append("FileUploadPath", "");
    this.uploadFile(fd, filetype);
  }

  CreateFormDataAndUpload(base64: any, filetype: any, FileName: any) {

    //extract base64 without data:type
    const base64WithoutDataType = base64.split(",")[1];

    //base64 to file
    let byteCharacters = atob(base64WithoutDataType);
    let byteNumbers = new Array(byteCharacters.length);
    for (var i = 0; i < byteCharacters.length; i++)
      byteNumbers[i] = byteCharacters.charCodeAt(i);

    let byteArray = new Uint8Array(byteNumbers);
    let blob = new Blob([byteArray], { type: "image/jpg" });
    const fileToBeUploaded = new File([blob], FileName);

    var fd = new FormData();
    fd.append("file", fileToBeUploaded);
    fd.append("filename", FileName);
    this.uploadFile(fd, filetype);
  }

  uploadFile(fd: FormData, filetype: string) {
    this.http.post<mdlStatus>(this.url.baseURL + "Proposal/SaveAttachmentsCentralizedNew", fd, this.userinfo.getHttpOptions3()).toPromise().then(
      async (res) => {
        if (res.StatusCode != "S") {
          this.ClearFileNames(filetype);
          Swal(`${filetype} Image Upload Failed: ` + res.StatusDesc, "", "error")
        }
      },
      (error) => {
        Swal(`${filetype} Image Upload Failed: ` + error.message, "", "error")
        this.ClearFileNames(filetype);
      });
  }

  GetTimeStamp(): string {
    const date = new Date();
    return `${date.getFullYear()}-${date.getMonth() + 1
      }-${date.getDate()} ${date.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      })}`;
  }

  ClearFileNames(FileType: string) {
    sessionStorage.removeItem(FileType + `ImgFileName`);
    sessionStorage.removeItem(FileType + `Img`);
    if (FileType == "front") {
      this.prObj.frontImage = null;
      this.attachments.frontImage = null;
      this.attachments.frontBase64Image = null;
    } else if (FileType == "back") {
      this.prObj.backImage = null;
      this.attachments.backImage = null;
      this.attachments.backBase64Image = null;
    } else if (FileType == "left") {
      this.prObj.leftImage = null;
      this.attachments.leftImage = null;
      this.attachments.leftBase64Image = null;
    } else if (FileType == "right") {
      this.prObj.rightImage = null;
      this.attachments.rightImage = null;
      this.attachments.rightBase64Image = null;
    } else if (FileType == "chasis") {
      this.prObj.chasisImage = null;
      this.attachments.chasisImage = null;
      this.attachments.chasisBase64Image = null;
    } else if (FileType == "InsuredId") {
      this.attachments.InsuredIdImage = null;
      this.prObj.InsuredIdImage = null;
    } else if (FileType == "Isthimara") {
      this.prObj.IsthimaraImage = null;
      this.attachments.IsthimaraImage = null;
      this.attachments.IsthimaraBase64Image = null;
    } else if (FileType == "CustomId") {
      this.prObj.CustomIdImage = null;
      this.attachments.CustomIdImage = null;
      this.attachments.CustomIdBase64Image = null;
    }
  }



  //<<<<<<<<New Image Upload Logic End>>>>>>>>>>>>




}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/MotorPortal/uploadsForm/uploadsForm.ts